/** Default for dashboard API calls after login (Kong → services). */
export const DEFAULT_API_FETCH_TIMEOUT_MS = 60000;

/** Login can be slower (Keycloak realm resolution, cold upstream). */
export const LOGIN_FETCH_TIMEOUT_MS = 90000;

/**
 * @param {unknown} error
 * @returns {error is Error & { timeout?: boolean, transient?: boolean }}
 */
export function isTimeoutError(error) {
  return Boolean(error && typeof error === "object" && error.timeout === true);
}

/**
 * `fetch` with a hard timeout so hung proxies/upstreams cannot leave the UI spinning forever.
 * @param {string} url
 * @param {RequestInit} [init]
 * @param {number} [timeoutMs]
 * @returns {Promise<Response>}
 */
export async function fetchWithTimeout(url, init = {}, timeoutMs = DEFAULT_API_FETCH_TIMEOUT_MS) {
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeoutMs);
  try {
    return await fetch(url, { ...init, signal: controller.signal });
  } catch (e) {
    const name = e && typeof e === "object" && "name" in e ? e.name : "";
    if (name === "AbortError") {
      const err = new Error(
        `Request timed out after ${Math.round(timeoutMs / 1000)}s. Check Kong, auth-service, and network.`
      );
      err.timeout = true;
      err.transient = true;
      throw err;
    }
    throw e;
  } finally {
    clearTimeout(id);
  }
}
